import { render, staticRenderFns } from "./order_list.vue?vue&type=template&id=ca4fb2c8&scoped=true&"
import script from "./order_list.vue?vue&type=script&lang=js&"
export * from "./order_list.vue?vue&type=script&lang=js&"
import style0 from "./order_list.vue?vue&type=style&index=0&id=ca4fb2c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4fb2c8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
